import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 px-5 text-center" data-testid="payment-cancel">
      <XCircle className="text-[#e0481f]" size={48} />
      <h1 className="headline text-3xl text-[#f7f3ec]">Checkout Cancelled</h1>
      <p className="text-[#a9a196]">No worries — your card was not charged.</p>
      <Link to="/events" className="btn-gold rounded-full px-6 py-3 font-display uppercase tracking-wide">Back To Events</Link>
    </div>
  );
}
